<script>
export default {
  props: {
    linkText: {
      type: String,
      default: ''
    },
    linkRouter: {
      type: String,
      default: ''
    },
    linkControl: {
      type: String,
      default: ''
    },
    linkSelect: {
      type: String,
      default: ''
    },
    linkType: {
      type: String,
      default: ''
    }
  }
}
</script>

<template>
  <li class="nav-item">
    <a
      class="nav-link"
      :class="[linkType]"
      :href="linkRouter"
      :aria-controls="linkControl"
      :aria-selected="linkSelect"
      role="tab"
    >
      {{ linkText }}
      <slot name="linkbr" />
      <slot name="linkfont" />
    </a>
  </li>
</template>
